module.exports = __webpack_public_path__ + "static/media/logos-print-salvadanaio.b0f856fd.jpg";